export default "__VITE_ASSET__CkQi5LrI__"